var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWorkoutGroupGymIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8C0 3.58172 3.58172 0 8 0H24C28.4183 0 32 3.58172 32 8V24C32 28.4183 28.4183 32 24 32H8C3.58172 32 0 28.4183 0 24V8Z",
    fill: "#A9C7FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19 22H24",
    stroke: "#000632"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 22H13",
    stroke: "#000632"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5185 13H8V24H24V13H17.4359",
    stroke: "#000632",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10 13V8H22V13",
    stroke: "#000632",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8 16H24",
    stroke: "#000632"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8 16H24",
    stroke: "#000632"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13 16V24",
    stroke: "#000632"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M19 16V24",
    stroke: "#000632"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M10 21L11 19",
    stroke: "#000632",
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M21 21V19",
    stroke: "#000632",
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkoutGroupGymIcon);
export default __webpack_public_path__ + "static/media/WorkoutGroupGymIcon.b5984a8c7d3da4fd77d380b73a9268ad.svg";
export { ForwardRef as ReactComponent };